import { Component, ChangeDetectionStrategy, effect, inject, input, output } from '@angular/core';
import { ViewTemplate } from '../../../models/template.model';
import { NotificationService } from '../../../shared/services/notification.service';
import {
  SelectTemplateDialogInputData,
  SelectTemplateDialogComponent,
} from '../../../shared/select-template-dialog/select-template-dialog.component';
import { filter } from 'rxjs/operators';
import { ReportView } from '../../../models/report.model';
import { L10nTranslationService, L10nTranslationModule } from 'angular-l10n';
import { UpperCasePipe } from '@angular/common';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'compare-actions-toolbar',
  templateUrl: './compare-actions-toolbar.component.html',
  styleUrl: './compare-actions-toolbar.component.scss',
  imports: [L10nTranslationModule, UpperCasePipe],
})
export class CompareActionsToolbarComponent {
  private readonly notificationService = inject(NotificationService);
  private readonly translationService = inject(L10nTranslationService);

  readonly templates = input.required<ViewTemplate[]>();
  readonly reportData = input.required<any>();
  readonly currentView = input.required<ReportView>();
  readonly recordList = input.required<any>();
  readonly isUKFeaturesEnabled = input<boolean>(false);
  readonly templateChange = output<number>();

  public selectedTemplate: ViewTemplate;
  public selectedTemplateTitle: string;

  constructor() {
    effect(() => {
      const currentView = this.currentView();
      const templates = this.templates();
      if (currentView && templates) {
        this.selectedTemplate = templates.find(temp => temp.templateId === currentView.templateId);
        this.selectedTemplateTitle = this.selectedTemplate
          ? `${this.selectedTemplate.templateName} ${this.translationService.translate('template.templateLbl')}`
          : '';
      }
    });
  }

  public openTemplates() {
    const options = { height: '90%', width: '90%', position: { top: '30px' } };
    const data: SelectTemplateDialogInputData = {
      templates: this.templates(),
      reportId: this.reportData().reportId,
      selectedTemplateId: this.currentView().templateId,
      viewId: this.currentView().id,
    };
    this.notificationService
      .openDialog<number>(SelectTemplateDialogComponent, data, options)
      .pipe(filter((selectedTemplate: number) => selectedTemplate != null))
      .subscribe(selectedTemplateId => this.templateChange.emit(selectedTemplateId));
  }
}
